module.exports = __webpack_public_path__ + "laos.svg?1de9d17cfc52b6f1a051f355089fdebf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/laos.svg
// module id = 209
// module chunks = 10